// Mobile Menu Toggle
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const mobileMenu = document.getElementById('mobileMenu');

// if (mobileMenuBtn) {
//   mobileMenuBtn.addEventListener('click', () => {
//     mobileMenu.classList.toggle('active');
//   });
// }

// Cart functionality
let cartCount = 0;
const cartCountElement = document.querySelector('.cart-count');

document.querySelectorAll('.product-btn').forEach(btn => {
    btn.addEventListener('click', function() {
        cartCount++;
        cartCountElement.textContent = cartCount;
        
        // Animation feedback
        this.textContent = 'AJOUTÉ !';
        this.style.background = '#28a745';
        
        setTimeout(() => {
            this.textContent = 'VOIR LE MODÈLE';
            this.style.background = '#333';
        }, 1500);
    });
});

// Smooth scroll for buttons
document.querySelectorAll('.btn, .view-all-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
        if (this.getAttribute('href') === '#') {
            e.preventDefault();
        }
    });
});

// Header scroll effect
window.addEventListener('scroll', () => {
    const header = document.querySelector('header');
    if (window.scrollY > 100) {
        header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
    } else {
        header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
    }
});


// ─── Spring engine ────────────────────────────────────────────────────────

/**
 * 1-D spring step. Mutates s = { pos, vel }.
 * Returns true when the spring has settled.
 */
function spring(s, target, k = 0.08, d = 0.72) {
  s.vel += (target - s.pos) * k
  s.vel *= d
  s.pos += s.vel
  return Math.abs(s.vel) + Math.abs(target - s.pos) < 0.05
}

/**
 * 2-D spring step. Mutates s = { x, y, vx, vy }.
 * Returns true when settled.
 */
function spring2D(s, tx, ty, k = 0.08, d = 0.72) {
  s.vx += (tx - s.x) * k;  s.vx *= d;  s.x += s.vx
  s.vy += (ty - s.y) * k;  s.vy *= d;  s.y += s.vy
  return Math.hypot(s.vx, s.vy) + Math.hypot(tx - s.x, ty - s.y) < 0.05
}

let _raf = null, _cleanup = () => {}

/**
 * rAF loop. Calls onTick() every frame until it returns true.
 * cleanup() is invoked when the loop is stopped or restarted.
 */
function loop(onTick, cleanup = () => {}) {
  cancelAnimationFrame(_raf)
  _cleanup(); _cleanup = cleanup
  function tick() { if (!onTick()) _raf = requestAnimationFrame(tick) }
  _raf = requestAnimationFrame(tick)
}

// const slides = document.querySelectorAll('.header-line-item');
// let current = 0;

// setInterval(() => {
//     slides[current].classList.remove('active');
//     slides[1].classList.add('active');
//     slides[2].classList.add('active');
// }, 3000);